<template>
  <span>
    <span
      class="badge badge-pill font-14 pl-2 pr-2 pt-1 pb-1"
      :class="statusClass"
      v-if="status"
    >
      {{status}}
    </span>
    <small
      class="ml-1"
      v-if="date"
    >
      Updated on <b>{{date | shortDateDisplay}}</b>
    </small>
  </span>
</template>

<script>
export default {
  name: "TrackingStatus",
  props: ["status", "date"],
  computed: {
    statusClass() {
      switch (this.status) {
        case 'Alert':
          return 'badge-danger';
        case 'Pre-Shipment':
          return 'badge-warning';
        case 'In-Transit':
        case 'Out for Delivery':
          return 'badge-info';
        case 'Delivered to Agent':
        case 'Delivery Attempt':
          return 'badge-light-blue';
        case 'Available for Pickup':
          return 'badge-teal'
        case 'Delivered':
          return 'badge-success';
        default:
          return 'badge-info';
      }
    },
  },
};
</script>
<style>
.badge-blue {
  background-color: #3722f6;
  color: white;
}
.badge-green {
  background-color: #00E676;
  color: white;
}
.badge-light-blue {
  background-color: #00B0FF;
  color: white;
}
.badge-teal {
  background-color: #00897B;
  color: white
}
</style>
